// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__PEHJT","modal":"Profile_modal__vuVX-","message":"Profile_message__JwuW6","close__btn":"Profile_close__btn__39J-V"};